import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import  routerHandle  from "./routerHandle";

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_ROUTER_BASE),
  routes: routes
});

routerHandle(router);

export default router;
export { routes };
